import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import { getWalletTransactionAction } from "../../../../redux/action/wallet";
import Pagination from "../../pagination/Pagination";
import TableLoader from "../../../loader/TableLoader";
import { formatRole } from "../../../../helpers/helpers";

function RecentTransactions() {
  const dispatch = useDispatch();
  const totalNumberRow = 100;
  const [currentPage, setCurrentPage] = useState(0);
  const { loading, recentTransaction } = useSelector(
    (state) => state.recentTransaction
  );

  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });

  useEffect(() => {
    dispatch(getWalletTransactionAction(currentPage, totalNumberRow,));
  }, [dispatch,currentPage, totalNumberRow,]);


  return (
    <div>
      {loading ? (
        <div className="valign-wrapper justify-center cover white">
          <TableLoader
            headerData={["Date", "Amount", "Status", "Transaction Category"]}
          />
        </div>
      ) : (
        <div className={`${!isTablet && "mt-1 table-container-style"}`}>
          <table
            className={`responsive-table centered ${
              isTablet ? "auction_table table-style" : "custom-table-style"
            } `}
          >
            <thead>
              <tr>
                <th></th>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Transaction Category</th>
              </tr>
            </thead>
            <tbody className="white">
              {recentTransaction
                ?.slice(currentPage, currentPage + totalNumberRow)
                ?.map((items, index) => (
                  <tr className="white black-text" key={items?._id}>
                    <td>
                      {items.status === "completed" ? (
                        <img
                          style={{ width: "30px" }}
                          src={`${process.env.PUBLIC_URL}/icons/${
                            items.amount < 0
                              ? "wallet-minus.svg"
                              : "wallet-add.svg"
                          }`}
                          alt="Icon"
                        />
                      ) : (
                        <img
                          style={{ width: "30px" }}
                          src={`${process.env.PUBLIC_URL}/icons/wallet-pending.svg`}
                          alt="Icon"
                        />
                      )}
                    </td>
                    <td>
                      <span>
                        {new Date(items.timestamp).toLocaleDateString("en-GB")}
                      </span>
                      <span> {items.time}</span>
                    </td>
                    <td>{items.amount}</td>
                    <td>{items.status}</td>
                    <td>{formatRole(items.type)}</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {recentTransaction?.length === 0 && (
            <div className="full-width column grey-text p-1  flex align-center justify-center ">
              <span className="material-symbols-outlined large-size ">
                receipt_long
              </span>
              <p>No data found.</p>
            </div>
          )}
        </div>
      )}
      <Pagination
        Data={recentTransaction}
        totalNumberRow={totalNumberRow}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}

export default RecentTransactions;
